import { getPaymentFrequencyAndDivisor } from '@ratehub/mtg-common';


function calculateTotalInterestEarned({
    initialInvestment,
    additionalContributions,
    additionalContributionsFrequency,
    timeHorizon,
    calculatedTotalInvestmentValue,
}) {
    if (initialInvestment == undefined || timeHorizon == undefined || calculatedTotalInvestmentValue == undefined) {
        return null;
    }

    // total interest earned calculation
    const mappedAdditionalContributionsFrequency = getPaymentFrequencyAndDivisor(additionalContributionsFrequency.toLowerCase()).frequency;
    const additionalInvestment = additionalContributions * mappedAdditionalContributionsFrequency * timeHorizon;

    return (parseFloat(calculatedTotalInvestmentValue) - initialInvestment - additionalInvestment).toString();
}

export default calculateTotalInterestEarned;
